import {useMemo} from 'react'
import {DateRangeType, PeriodType} from '../../../global'

export const usePeriod = (dateRange: DateRangeType): PeriodType => {
    const [dateTimeStart, dateTimeEnd] = dateRange ?? [null, null]

    return useMemo(() => {

          if (dateTimeStart && dateTimeEnd) {
              return {
                  start: `${dateTimeStart.getDate()}-${dateTimeStart.getMonth() + 1}-${dateTimeStart.getFullYear()}`,
                  end: `${dateTimeEnd.getDate()}-${dateTimeEnd.getMonth() + 1}-${dateTimeEnd.getFullYear()}`,
              }
          }
          return {start: '', end: ''}
      },
      [dateRange])
}